import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { faHeart as faHeartUnchecked } from '@fortawesome/free-regular-svg-icons';
import { faHeart } from '@fortawesome/free-solid-svg-icons';
import { CourseService } from 'src/app/services/course.service';

@Component({
    selector: 'app-favourite-course',
    templateUrl: './favourite-course.component.html',
    styleUrls: ['./favourite-course.component.scss'],
    standalone: false
})

export class FavouriteCourseComponent {
  @Input() course: any = {};
  @Input() userId: string = '';
  @Output() notifyParent: EventEmitter<void> = new EventEmitter();

  faHeart = faHeart;
  faHeartUnchecked = faHeartUnchecked;

  constructor(public courseservice: CourseService)
  {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      if (this.course.favoriteFlag) {
        this.course.favoriteIcon = faHeart;
      } else {
        this.course.favoriteIcon = faHeartUnchecked;
      }
    }

    if (!this.course.courseRecordId){
      this.course.courseRecordId = this.course.id;
    }
  }

  public toggleFavourite(courseId: string, userId: string): Promise<boolean>{
    return new Promise((resolve, reject) => {
      this.courseservice.toggleFavouriteCourse(courseId, userId).subscribe({
        next: (response: boolean) => {
          this.notifyParent.emit();
        },
        error: (error) => {
          reject(error);
        }
      });
    });
  }
}
